module.exports = __webpack_public_path__ + "images/emoji/hotsprings.257aa464c5e029675090.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hotsprings.png
// module id = 1UNf
// module chunks = 24